import { defineMessages } from '@jutro/locale';

export default defineMessages({
    allStatuses: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportAdditionalFilter.All Statuses',
        defaultMessage: 'All Statuses'
    },
    status: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportAdditionalFilter.Status',
        defaultMessage: 'Status'
    }
});
